module.exports = __webpack_public_path__ + "a019a7c762bd071f610951765208a3a6.svg";